import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsBar = ({ 
  selectedCount, 
  onClearSelection, 
  onBulkDelete, 
  onBulkExport,
  onBulkCategoryChange,
  categories = [],
  className = '' 
}) => {
  const [selectedAction, setSelectedAction] = useState('');
  const [targetCategory, setTargetCategory] = useState('');

  const actionOptions = [
    { value: 'export', label: 'تصدير المحدد' },
    { value: 'delete', label: 'حذف المحدد' },
    { value: 'change-category', label: 'تغيير الفئة' },
    { value: 'activate', label: 'تفعيل المحدد' },
    { value: 'deactivate', label: 'إلغاء تفعيل المحدد' }
  ];

  const categoryOptions = categories?.map(cat => ({
    value: cat?.id,
    label: getCategoryLabel(cat?.id)
  }));

  function getCategoryLabel(categoryId) {
    switch (categoryId) {
      case 'board':
        return 'مجلس الإدارة';
      case 'supervisory':
        return 'الهيئة الإشرافية';
      case 'electoral':
        return 'اللجنة الانتخابية';
      case 'offices':
        return 'المكاتب';
      default:
        return categoryId;
    }
  }

  const handleActionExecute = () => {
    switch (selectedAction) {
      case 'export':
        onBulkExport();
        break;
      case 'delete':
        onBulkDelete();
        break;
      case 'change-category':
        if (targetCategory) {
          onBulkCategoryChange(targetCategory);
        }
        break;
      case 'activate':
        // Handle bulk activate
        break;
      case 'deactivate':
        // Handle bulk deactivate
        break;
    }
    
    setSelectedAction('');
    setTargetCategory('');
  };

  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className={`bg-primary text-primary-foreground rounded-lg p-4 shadow-elevation-2 animate-slide-up ${className}`}>
      <div className="flex items-center justify-between">
        {/* Selection Info */}
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={20} />
            <span className="font-medium">
              تم تحديد {selectedCount} منصب
            </span>
          </div>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            className="text-primary-foreground hover:bg-primary-foreground/10"
            iconName="X"
            iconPosition="left"
            iconSize={14}
          >
            إلغاء التحديد
          </Button>
        </div>

        {/* Bulk Actions */}
        <div className="flex items-center space-x-3">
          {/* Action Selection */}
          <div className="flex items-center space-x-2">
            <Select
              options={actionOptions}
              value={selectedAction}
              onChange={setSelectedAction}
              placeholder="اختر إجراء"
              className="min-w-40"
            />
            
            {selectedAction === 'change-category' && (
              <Select
                options={categoryOptions}
                value={targetCategory}
                onChange={setTargetCategory}
                placeholder="اختر الفئة"
                className="min-w-40"
              />
            )}
          </div>

          {/* Execute Button */}
          <Button
            variant="secondary"
            size="sm"
            onClick={handleActionExecute}
            disabled={!selectedAction || (selectedAction === 'change-category' && !targetCategory)}
            iconName="Play"
            iconPosition="left"
            iconSize={14}
          >
            تنفيذ
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;